import { Alert } from '@cmsgov/design-system'
import { useTranslation } from 'react-i18next'

export const GenericError = () => {
  const { t } = useTranslation('common')
  return (
    <Alert variation='warn'>
      {t('error.generic')}
    </Alert>
  )
}
